import { useState, useEffect } from 'react';
import { Upload } from 'antd';
import apis from '@/apis';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { beforeUpload } from './utils';

const customRequest = ({ action, data, file, filename, headers, onError, onProgress, onSuccess, withCredentials }) => {
  const formData = new FormData();
  formData.append('file', file);
  apis
    .uploadPic(formData)
    .then((res) => {
      const { ret } = res;
      if (ret === '0' && res.data) {
        onSuccess(
          {
            name: filename,
            status: 'done',
            thumbUrl: res.data.urlList[0],
            url: res.data.urlList[0],
          },
          file
        );
      } else {
        onError();
      }
    })
    .catch(onError);

  return {
    abort() {
      console.log('upload progress is aborted.');
    },
  };
};

function UploadImg(props) {
  const { value, onChange, checkParams = {}, name = 'file', btnText = '上传图片', showDelete, ...otherProps } = props;
  const { width = null, height = null, max = null, accept = '' } = checkParams;
  const [innerValue, setInnerValue] = useState(value);
  const [loading, setLoading] = useState(false);

  let contentInLoadBtn = null;

  if (loading) contentInLoadBtn = <LoadingOutlined />;
  else {
    // 初始化
    if (!innerValue)
      contentInLoadBtn = (
        <div>
          <PlusOutlined />
          {btnText && <div style={{ marginTop: 8 }}>{btnText}</div>}
        </div>
      );
    else {
      contentInLoadBtn = <img src={innerValue} alt="avatar" style={{ maxHeight: '100%', maxWidth: '100%' }} />;
    }
  }

  useEffect(() => {
    if ('value' in props) setInnerValue(value);
    // eslint-disable-next-line
  }, [value]);

  function handleChange(picValue) {
    if (!('value' in props)) {
      setInnerValue(picValue);
    }

    onChange?.(picValue);
  }

  const handlePicChange = (info) => {
    switch (info.file.status) {
      case 'uploading':
        setLoading(true);
        break;
      case 'done':
        setLoading(false);
        handleChange(info.file.response.url);
        break;
    }
  };

  return (
    <>
      <Upload
        name={name}
        listType="picture-card"
        showUploadList={false}
        customRequest={customRequest}
        disabled={loading}
        beforeUpload={(file) => {
          return beforeUpload(file, accept, width, height, max);
        }}
        onChange={handlePicChange}
        {...otherProps}
      >
        {contentInLoadBtn}
      </Upload>
      {showDelete && innerValue && (
        <div>
          <a onClick={() => onChange('')}>删除</a>
        </div>
      )}
    </>
  );
}

export default UploadImg;
